import * as ng from 'angular';
import { FileService } from '../../../../../services/file.service';

export const NotificationsModalComponent = {
    template: require('./notifications-modal-component.html'),
    controller: class NotificationsModalComponent {

        static $inject: string[] = [
            'FileService'
        ];

        private item: any;
        private statoDescription: any;

        private resolve: any;
        private close: any;

        constructor(
            private fileService: FileService
        ) {}

        $onInit(): void {
            this.item = this.resolve.invoice;
            this.statoDescription = this.resolve.stato;
        }

        ok(): void {
            this.close();
        }

        computeStateLabelClass(status: string): string {
            switch (status) {
            case 'Scartata':
                return 'label-default';
            case 'Generata':
                return 'label-primary';
            case 'Accettata':
                return 'label-success';
            case 'Consegnata':
                return 'label-info';
            case 'Trasmessa allo SdI':
            case 'Non ancora consegnata':
            case 'Presa in carico':
                return 'label-warning';
            case 'Rifiutata':
            case 'Decorsi i termini':
            case 'Non recapitabile':
                return 'label-danger';
            case 'Nel cassetto':
                return 'label-purple';
            default:
                return '';
            }
        }

        downloadNotification(filePath: string): void {
            this.fileService.downloadFile(filePath);
        }
    },
    bindings: {
        resolve: '<',
        close: '&'
    }
};



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/app/sections/home/fatturazione/component/notifications-modal-component/notifications-modal-component.ts